export const AUTOMATIC_VOUCHER_CODE_OFF = 'OFF'
